import * as React from "react";
import {colors} from "../../master";
import { useState } from "react"
import { ProductColor } from "./ProductColor"
import { ProductPrice } from "./ProductPrice"

type ProductDetailProps = {
  id: string,
  name: string,
  capacity: number,
  colors: string[],
  defaultColor: string,
  price: number,
  salePrice?: number,
  description: string,
  url: string,
}

export const ProductDetail: React.FC<ProductDetailProps> = (
  {
    id,
    name,
    capacity,
    colors: colorIds,
    defaultColor,
    price,
    salePrice,
    description,
    url
  }
) => {
  const [currentColor, setCurrentColor] = useState(defaultColor)

  const image = colorIds.reduce((sub, colorId) => {
    if (colorId !== currentColor) return sub

    const imageSrc = require(`../../images/product-${id}-${colorId}.png`)
    const color = colors.find(({id}) => id === colorId)

    return <img src={imageSrc} alt={color.name}/>
  }, <img src={require(`../../images/product-${id}.png`)} alt={name}/>)

  return (
    <>
      <div
        className="w-3/5 h-16 flex items-center m-auto p-0.5 text-lg border-t border-b border-black lg:m-0 lg:w-full lg:bg-black lg:text-white lg:leading-7 lg:text-2xl lg:py-2 lg:sticky lg:top-0">
        <div className="text-center w-full">
          {name}&nbsp;<br className="hidden lg:inline"/>{capacity.toString()}Wh
        </div>
      </div>
      <div className="pb-4 lg:bg-white">
        <div className="w-4/5 p-3 m-auto lg:pt-8 lg:pb-6">
          {image}
        </div>
        <div className="grid grid-cols-3 p-3 w-4/5 h-32 m-auto lg:pb-0 lg:w-full lg:h-auto lg:flex lg:justify-center">
          {colorIds.map(id => (
            <ProductColor
              key={id}
              currentColor={currentColor}
              colorId={id}
              onMouseEnter={() => setCurrentColor(id)}
            />
          ))}
        </div>
        <ProductPrice price={price} salePrice={salePrice}/>
        <div className="w-4/5 h-40 m-auto bg-white p-4 mt-5 lg:w-full lg:mt-0" style={{fontSize: "11px"}}>
          <a href={url} className="bg-black text-white block text-center text-2xl p-1 mb-4 lg:rounded-md">
            詳細はこちら
          </a>
          <p className="lg:border-t lg:border-dashed lg:border-gray-400 lg:pt-4 lg:h-16">
            {description}
          </p>
        </div>
      </div>
    </>
  )
}
